export default class Cancel extends Error {}
